/**
 * Loads a script.
 * @param {string} src - Url of script to load.
 * @returns {Promise}
 */
function loadScript(src) {
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.body.appendChild(s);
  });
}

/* global DetailsDisclosure, trapFocus, removeTrapFocus */

if (!customElements.get('kit-drawer-disclosure')) {
  class KitDrawerDisclosure extends DetailsDisclosure {
    constructor() {
      super();
      this.openBtn = this.querySelector('.kit-drawer-open-button');
      this.closeBtn = this.querySelector('.js-close');
      this.overlay = document.getElementById('kit-drawer').querySelector('.overlay');
    }

    /**
     * Handles 'click' events on the custom element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (!evt.target.matches('.js-close')) return;
      this.close();
    }

    /**
     * Opens the details element.
     */
    open() {
      this.overlay.classList.add('is-visible');
      super.open();
      trapFocus(this);

      // Create event handler variables (so the bound event listeners can be removed).
      this.clickHandler = this.clickHandler || this.handleClick.bind(this);
      this.keyupHandler = (evt) => evt.key === 'Escape' && this.close();

      // Add event listeners (for while disclosure is open).
      this.addEventListener('click', this.clickHandler);
      this.addEventListener('keyup', this.keyupHandler);
      this.overlay.addEventListener('click', this.clickHandler);
    }

    /**
     * Closes the details element.
     */
    close() {
      this.overlay.classList.remove('is-visible');
      super.close();
      removeTrapFocus(this.openBtn);

      this.removeEventListener('click', this.clickHandler);
      this.removeEventListener('keyup', this.keyupHandler);
      this.overlay.removeEventListener('click', this.clickHandler);
    }
  }

  customElements.define('kit-drawer-disclosure', KitDrawerDisclosure);
}

/* global SideDrawer */

if (!customElements.get('kit-drawer')) {
  class KitDrawer extends SideDrawer {
    constructor() {
      super();

      this.cartSummary = this.querySelector('.kit-drawer__summary');
      this.init();
      this.bindEvents();
    }

    disconnectedCallback() {
      document.removeEventListener('dispatch:kit-drawer:refresh', this.refreshHandler);
      document.removeEventListener('dispatch:kit-drawer:open', this.openDrawerViaEventHandler);
      document.removeEventListener('dispatch:kit-drawer:close', this.closeDrawerViaEventHandler);

      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:select', this.sectionSelectHandler);
        document.removeEventListener('shopify:section:deselect', this.sectionDeselectHandler);
      }

      if (this.dcbLoadedHandler) {
        document.removeEventListener('shopify:payment_button:loaded', this.dcbLoadedHandler);
      }
    }

    init() {
      if (document.querySelector('.kit-button')) {
        document.body.addEventListener('click', (evt) => {
          try {
            const kitButton = evt.target.classList.contains('.kit-button') ? evt.target : evt.target.closest('.kit-button')
            
            if(kitButton) {
              const kitMetafieldContainer = kitButton.nextElementSibling;
  
              if(!kitMetafieldContainer) return;

              const kitImageContainer = kitMetafieldContainer.nextElementSibling;

              if(kitImageContainer) {
              const kitImageContent = kitImageContainer.innerHTML;
              this.querySelector('.kit-drawer__item-preview').innerHTML = kitImageContent || '';
                
              }
  
              const kitContent = kitMetafieldContainer.innerHTML;
  
              if(!kitContent) return;
  
              this.querySelector('.kit-drawer__content').innerHTML = kitContent;
  
              evt.preventDefault();
              evt.stopPropagation();
              this.open();
              return
            }
          } catch (error) {
            console.error(error)
          }
        });
      }
    }

    bindEvents() {
      if (Shopify.designMode) {
        this.sectionSelectHandler = this.handleSectionSelect.bind(this);
        this.sectionDeselectHandler = this.handleSectionDeselect.bind(this);
        document.addEventListener('shopify:section:select', this.sectionSelectHandler);
        document.addEventListener('shopify:section:deselect', this.sectionDeselectHandler);
      }

      this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
      this.closeDrawerViaEventHandler = this.close.bind(this, null);
      document.addEventListener('dispatch:kit-drawer:open', this.openDrawerViaEventHandler);
      document.addEventListener('dispatch:kit-drawer:close', this.closeDrawerViaEventHandler);



      this.refreshHandler = this.refresh.bind(this);
      document.addEventListener('dispatch:kit-drawer:refresh', this.refreshHandler);
    }

    /**
     * Handle when the section is selected in the Theme Editor
     * @param {object} evt - Event object.
     */
    handleSectionSelect(evt) {
      if (evt.target === this.closest('.shopify-section')) this.open();
    }

    /**
     * Handle when the section is de-selected in the Theme Editor
     * @param {object} evt - Event object.
     */
    handleSectionDeselect(evt) {
      if (evt.target === this.closest('.shopify-section')) this.close();
    }

    /**
     * Handle when the drawer is opened via an event
     * @param {object} evt - Event object.
     */
    handleDrawerOpenViaEvent(evt) {
      this.open(evt.detail ? evt.detail.opener : null);
    }

    open(opener, elementToFocus) {
       const overlay = document.querySelector('.js-overlay.is-visible');
       super.open(opener, elementToFocus, () => {});
      
       if (overlay) overlay.style.transitionDelay = '';
    }
    async refresh() {
      try {
        console.log('refreshing...')
     
      } catch (error) {
        console.log(error); // eslint-disable-line
      }
    }

    /**
     * Renders the contents of the specified sections to update.
     * @param {object} data - Cart data object.
     * @param {boolean} [openDrawer=true] - Open the cart drawer after rendering sections.
     */
    async renderContents(data, openDrawer = true) {
      if (openDrawer && this.getAttribute('open') === null) {
        setTimeout(() => this.open());
      }
    }

    /**
     * Dispatches an event to recalculate the data-css-var-heights on the page. Useful for
     * updating the height of the sticky cart buttons
     */
    static recalculateCssVarHeights() {
      window.requestAnimationFrame(() => {
        document.dispatchEvent(new CustomEvent('on:css-var-height:update'));
      });
    }

    /**
     * Gets the innerHTML of an element.
     * @param {string} html - Section HTML.
     * @param {string} selector - CSS selector for the element.
     * @returns {string}
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      return tmpl.content.querySelector(selector).innerHTML;
    }
  }

  customElements.define('kit-drawer', KitDrawer);
}